import styles from "./InsuranceHint.module.css";
import { useI18n } from "../../i18n";
import { Trans } from "react-i18next";

interface InsuranceHintProps {
  selfPayment?: boolean;
  employeePaysInsurance?: boolean;
}

const InsuranceHint = ({ selfPayment, employeePaysInsurance }: InsuranceHintProps) => {
  const { t } = useI18n();
  if (!selfPayment && !employeePaysInsurance) {
    return null;
  }
  return (
    <div className={styles.container}>
      {employeePaysInsurance ? (
        <span className={styles.title}>
          <div>{t("hints.insuranceEmployeePays.1")}</div>
          <div>{t("hints.insuranceEmployeePays.2")}</div>
        </span>
      ) : null}
      {selfPayment ? (
        <span className={styles.title}>
          <Trans i18nKey={"hints.insuranceSelfPayment"} t={t} />
        </span>
      ) : null}
    </div>
  );
};

export { InsuranceHint };
